<template>
<span>

          <v-tooltip bottom>
              <v-btn slot="activator" 
                      color="yellow darken-4"
                      icon
                      flat
                      text-color="white"
                      dark
                      @click.native="openModal()">
                  <v-icon class="material-icons"  dark color="yellow darken-4">vertical_split</v-icon>
              </v-btn>
              <span>Ver colunas personalizáveis</span>
          </v-tooltip>
        <v-dialog @keydown.esc="dialog = false" v-model="dialog" max-width="500px">
            <v-card>
            <v-card-title>
                <span><strong>Colunas personalizáveis</strong></span>
                <v-spacer></v-spacer>
                <v-menu bottom left>
                <v-list>
                    <v-list-tile>
                    <v-list-tile-title>
                        
                    </v-list-tile-title>
                    </v-list-tile>
                </v-list>
                </v-menu>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text id="tst">
                        <v-container grid-list-md>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                            <h4>{{text}}</h4>
                            <ol>
                              <li v-for="(item,i) in table.auxHeaders" :key="i" v-if="item.value.indexOf('custom_') != -1" >
                                <div style="display: inline-block; min-width: 50%;">{{item.text}}</div>

                                    <btnEditColumn :table="table" :item="item" @mergeColumn="mergeColumn($event)"></btnEditColumn>
                                    <v-tooltip bottom>
                                        <v-btn slot="activator" 
                                                color="red darken-4"
                                                icon
                                                flat
                                                text-color="white"
                                                dark
                                               @click="removeColumn(item,i)">
                                            <v-icon class="material-icons"  dark color="red darken-4">delete_forever</v-icon>
                                        </v-btn>
                                        <span>Remover esta coluna personalizáveil</span>
                                    </v-tooltip>
                                    

                              </li>
                            </ol>
                            </v-flex>
                        </v-layout>
                        </v-container>
                    </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="primary" flat @click.stop="dialog=false">Fechar</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>

 
</span>

</template>

<script>
import NfeService from "@/domain/notas/nfe/NfeService";
import btnEditColumn from "./../btnEditColumn/BtnEditColumn.vue";
export default {
  props: ["table"],
  components: {
    btnEditColumn: btnEditColumn
  },
  data: () => ({
    dialog: false,
    columnName: "",
    text: ""
  }),
  watch: {
    "table.auxHeaders": function() {
      this.vrfcaColumn;
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.vrfcaColumn;
    });
  },
  computed: {
    vrfcaColumn: function() {
      let aux_text = "";
      let aux_temColumn = false;
      aux_text = "Não há colunas personalizáveis";
      this.table.auxHeaders.forEach(function(item) {
        if (item.value.indexOf("custom_") != -1) {
          aux_text = "Coluna personalizáveis existente: ";
        }
      });
      this.text = aux_text;
    }
  },
  methods: {
    openModal: function() {
      this.dialog = true;
    },
    removeColumn: function(columnItem, i) {
      let id = columnItem.value;
      this.table.auxHeaders.splice(i, 1);

  
      this.table.snack.text = `Coluna: "${columnItem.text}" removida da tabela`;
      this.table.snackDanger();
      this.table.snack.show = true;
    },
    mergeColumn($event) {
      
    }
  }
};
</script>
<style scoped>
li {
  cursor: pointer;
  padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnColumn/btnRmvColumn/BtnRmvColumn.vue